import { CategoryNode } from '../types/category';

/**
 * 按二级类目分组并分配到三列
 */
export const groupCategoriesIntoColumns = (category: CategoryNode): CategoryNode[][] => {
  if (!category.children) return [[], [], []];
  
  const secondLevelCategories = category.children;
  const totalGroups = secondLevelCategories.length;
  
  // 计算每列的分组数量
  const baseCount = Math.floor(totalGroups / 3);
  const remainder = totalGroups % 3;
  
  const columnCounts = [
    baseCount + (remainder > 0 ? 1 : 0),
    baseCount + (remainder > 1 ? 1 : 0),
    baseCount
  ];
  
  const columns: CategoryNode[][] = [[], [], []];
  let startIndex = 0;
  
  columnCounts.forEach((count, columnIndex) => {
    columns[columnIndex] = secondLevelCategories.slice(startIndex, startIndex + count);
    startIndex += count;
  });
  
  return columns;
};